export default __webpack_public_path__ + "static/media/south-america-countries.a8b3f6c3.geojson";